import { useEffect } from 'react';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import { type Banner } from '../types';
import { bannerApi } from '../api';
import { bannerKeys } from './banner.keys';

export function useBanners(
  options?: Omit<UseQueryOptions<Banner[], Error>, 'queryKey' | 'queryFn'>
) {
  const query = useQuery({
    queryKey: bannerKeys.list(),
    queryFn: ({ signal }) => bannerApi.list(signal),
    staleTime: 60_000,
    ...(options as Omit<UseQueryOptions<Banner[], Error>, 'queryKey' | 'queryFn'>),
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      title: 'Erro ao buscar banners',
      description: query.error.message,
      variant: 'destructive',
    });
  }, [query.error]);

  return {
    banners: query.data ?? [],
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
    queryResult: query,
  };
}
